export default __webpack_public_path__ + "static/media/Appstore.7ad8e188.svg";